export default __webpack_public_path__ + "static/media/hostfully_step5.f7a584d8.png";